//GeneratorFlag:[NoChange]
import Discount from './discount';

export default {Discount}
export{Discount}